<template>
  <div :class="distinguish == 1 ? 'cola-list1' : 'cola-list'">
    <div class="cola-list-i" v-for="(item, i) in list" v-show="item.status == 0" :key="i">
      <div class="cola-list-img">
        <img :src="nubre == i ? list1[i] : nubre == 8 ? list1[i] : item.imgag" alt />
      </div>
      <div class="cola-list-acvie">
        <div class="cola-list-acvie-g"></div>
        <div
          class="cola-list-acvie-name"
          :style="{
            backgroundImage:
              nubre == i
                ? `url(${imgag})`
                : nubre == 8
                  ? `url(${imgag})`
                  : `url(${imgag1})`,
          }"
          @click="avice(i)"
        >{{ item.name }}</div>
      </div>
    </div>
    <div class="backimg"></div>
  </div>
</template>
<script>
export default {
  props: ["distinguish"],
  data() {
    return {
      nubre: -1,
      list: [
        {
          imgag: require("../../../assets/sb/cocgq.png"),
          name: "CO传感器",
          status: 0
        },
        {
          imgag: require("../../../assets/sb/wscgq.png"),
          name: "瓦斯传感器",
          status: 0
        },
        {
          imgag: require("../../../assets/sb/ywcgq.png"),
          name: "烟雾传感器",
          status: 0
        },
        {
          imgag: require("../../../assets/sb/ducgq.png"),
          name: "温度传感器",
          status: 0
        },
        {
          imgag: require("../../../assets/sb/fcldcgq.png"),
          name: "粉尘浓度传感器",
          status: 0
        }
      ],
      list1: [
        require("../../../assets/sb/COcgq2.png"),
        require("../../../assets/sb/wscgq0.png"),
        require("../../../assets/sb/ywcgq0.png"),
        require("../../../assets/sb/wdcgq4.png"),
        require("../../../assets/sb/fcldcgq1.png"),
      ],
      imgag: require("../../../assets/sb/back.png"),
      imgag1: require("../../../assets/sb/back1.png"),
      beselist: [],
      beselist1: []
    };
  },
  mounted() {
    // app.vue 传过来的 请求到的设备json
    this.emit.$on("beselist", e => {
      this.beselist = e;
    });
    // app.vue 传过来的 请求到的设备json
    this.emit.$on("beselist1", e => {
      this.beselist1 = e;
    });
    // right.vue 传过来的  ，l/mksvbm，你，
    this.emit.$on("item", e => {
      // console.log(e, "dada");
      if (e == 0) {
        this.list.forEach(item => {
          item.status = 0;
        });
      } else if (e == 1) {
        // list[]
      } else if (e == 2) {
      }
      this.nubre = 100;
    });
    window.chgng = this.chgng;
  },
  methods: {
    // 设备选中函数
    avice(i) {
      if (this.nubre == i) {
        //
        document.getElementById("iframe").contentWindow.MMAPI.list(i + "");
        // 传到 app.vue
        this.emit.$emit("show");
        this.nubre = 100;
        return;
      }
      this.nubre = i;
      // 传到 app.vue
      this.emit.$emit("show");
      // 三维 设备显示
      document
        .getElementById("iframe")
        .contentWindow.MMAPI.list(i + "", this.beselist);
      if (i == 8) {
        document
          .getElementById("iframe")
          .contentWindow.MMAPI.all(this.beselist1); // 显示全部设备
      }
    },
    chgng() {
      // 取消设备选中状态
      document
        .getElementById("iframe")
        .contentWindow.MMAPI.list(this.nubre + "");
      this.emit.$emit("show"); // 传到 app.vue
      this.nubre = 100;
    }
  }
};
</script>
<style lang="less" scoped>
.cola-list {
  width: 15vw;
  height: 80%;
  margin-left: 2vw;
  transition: all 2s;
  transform: translateY(210%);
}
.cola-list1 {
  width: 15vw;
  height: 80%;
  margin-left: 2vw;
  transition: all 1s;
  transform: translateY(0%);
}
.backimg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("../../../assets/arc.png");
  background-size: auto 100%;
  background-repeat: no-repeat;
  z-index: -1;
}

.cola-list > div:first-child {
  width: 12vw;
  height: 6vh;
  margin-top: 1.5vh;
  margin-left: 2vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cola-list > div:nth-child(2) {
  width: 12vw;
  height: 6vh;
  margin-top: 1.4vh;
  margin-left: 0vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cola-list > div:nth-child(3) {
  width: 12vw;
  height: 6vh;
  margin-top: 2vh;
  margin-left: -1vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cola-list > div:nth-child(4) {
  width: 12vw;
  height: 6vh;
  margin-top: 2vh;
  margin-left: -1.5vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cola-list > div:nth-child(5) {
  width: 12vw;
  height: 6vh;
  margin-top: 2vh;
  margin-left: -2vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cola-list-acvie {
  width: 70%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .cola-list-acvie-g {
    width: 60%;
    height: 2vh;
    padding: 0 1vw 0 0;
    text-align: right;
    img {
      width: 20%;
      height: auto;
    }
  }
  .cola-list-acvie-name {
    display: flex;
    align-items: center;
    padding: 0.2vw 0 0.2vw 0.5vw;
    background-size: 60% 100%;
    background-repeat: no-repeat;
    color: #fff;
    font-size: 0.5vw;
    letter-spacing: 0.2vw;
    cursor: pointer;
  }
}
.cola-list-img {
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    height: auto;
  }
}
.cola-list1 > div:first-child {
  width: 12vw;
  height: 6vh;
  margin-top: 14vh;
  margin-left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: move 1.5s ease 1s 1 normal backwards;
}
.cola-list1 > div:nth-child(2) {
  width: 12vw;
  height: 6vh;
  margin-top: 3.5vh;
  margin-left: -1.5vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: move 1.5s ease 1.2s 1 normal backwards;
  // animation-delay: 2s;
}

.cola-list1 > div:nth-child(3) {
  width: 12vw;
  height: 6vh;
  margin-top: 3vh;
  margin-left: -2vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: move 1.5s ease 1.4s 1 normal backwards;
}
.cola-list1 > div:nth-child(4) {
  width: 12vw;
  height: 6vh;
  margin-top: 4vh;
  margin-left: -1.5vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: move 1.5s ease 1.6s 1 normal backwards;
}
.cola-list1 > div:nth-child(5) {
  width: 12vw;
  height: 6vh;
  margin-top: 4vh;
  margin-left: -0.5vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: move 1.5s ease 1.8s 1 normal backwards;
}
</style>